import script from "./SampleCostView.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleCostView.vue?vue&type=script&setup=true&lang=js"

import "./SampleCostView.vue?vue&type=style&index=0&id=5e3227a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3227a6"]])

export default __exports__